export const templateVariables = {
  customerName: {
    description: "Customer's full name",
    example: "John Doe"
  },
  service: {
    description: "Service name",
    example: "Haircut"
  },
  date: {
    description: "Appointment date",
    example: "Monday, January 1, 2024"
  },
  time: {
    description: "Appointment time",
    example: "10:00 AM"
  },
  oldDate: {
    description: "Original appointment date",
    example: "Tuesday, March 10, 2026"
  },
  oldTime: {
    description: "Original appointment time",
    example: "9:30 AM"
  },
  newDate: {
    description: "Updated appointment date",
    example: "Wednesday, March 11, 2026"
  },
  newTime: {
    description: "Updated appointment time",
    example: "1:15 PM"
  },
  provider: {
    description: "Service provider's name",
    example: "Jane Smith"
  },
  depositAmount: {
    description: "Amount paid as deposit",
    example: "$50.00"
  },
  remainingBalance: {
    description: "Remaining balance to be paid",
    example: "$100.00"
  },
  balanceAmount: {
    description: "Amount paid as balance payment",
    example: "$100.00"
  },
  totalAmount: {
    description: "Total amount for the service",
    example: "$150.00"
  },
  portalUrl: {
    description: "Customer booking portal URL",
    example: "https://scheduler.app/bookings/manage"
  }
};

// Helper function to get all variable names
export const getVariableNames = () => Object.keys(templateVariables);

// Helper function to replace variables with examples
export const replaceWithExamples = (template) => {
  let result = template;
  Object.entries(templateVariables).forEach(([key, value]) => {
    result = result.replace(
      new RegExp(`{{${key}}}`, 'g'),
      value.example
    );
  });
  return result;
}; 